<div class="layout-wrapper" (click)="onLayoutClick()" [ngClass]="{'layout-horizontal': isHorizontal(),
                 'layout-overlay': isOverlay(),
                 'layout-static': isStatic(),
                 'layout-slim':isSlim(),
                 'layout-static-inactive': staticMenuDesktopInactive,
                 'layout-mobile-active': staticMenuMobileActive,
                 'layout-overlay-active':overlayMenuActive}">

    <app-header></app-header>
    <div class="layout-menu-container" (click)="onMenuClick()">
        <div class="layout-menu-content">
            <!-- <div class="layout-menu-title">PRESUPUESTOS</div> -->
            <app-menu [model]="model"></app-menu>
            <!-- <div class="layout-menu-footer">
                <div class="layout-menu-footer-title">TASKS</div>

                <div class="layout-menu-footer-content">
                    <p-progressBar [value]="50" [showValue]="false"></p-progressBar>
                    Today

                    <p-progressBar [value]="80" [showValue]="false"></p-progressBar>
                    Overall
                </div>
            </div> -->
        </div>
    </div>

    <div class="layout-content">

        <app-header-breadcrumb></app-header-breadcrumb>

        <div class="layout-content-container">
            <router-outlet></router-outlet>
        </div>

        <!-- <app-config></app-config> -->
        <app-footer></app-footer>

        <div class="layout-mask" *ngIf="staticMenuMobileActive"></div>
    </div>
</div>